import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import { KitService } from '../../services/kit.service';
import { KitComponents } from '../../interfaces/inventory/kit.interface';

/**
 * F6c: under a kit line, what one kit holds and how many whole kits the store can make now
 * (min over components of floor(stock / qty)). Silent when the lookup fails.
 */
const KitAvailabilityHint: React.FC<{ institutionId: string; kitItemId: string; storeId?: string | null; where?: string }> = ({ institutionId, kitItemId, storeId, where = 'in the default store' }) => {
  const [kit, setKit] = useState<KitComponents | null>(null);

  useEffect(() => {
    let live = true;
    setKit(null);
    KitService.get(institutionId, kitItemId, storeId)
      .then(k => { if (live) setKit(k); })
      .catch(() => { if (live) setKit(null); });
    return () => { live = false; };
  }, [institutionId, kitItemId, storeId]);

  if (!kit) return null;
  if (kit.components.length === 0) {
    return <Typography variant="caption" color="warning.main" data-testid="kit-hint">Kit with no components yet: it cannot be delivered.</Typography>;
  }
  const parts = kit.components.map(c => `${c.quantity} × ${c.code ?? c.name ?? 'item'}`).join(' + ');
  return (
    <Typography variant="caption" color="text.secondary" component="div" data-testid="kit-hint">
      Kit: {parts}
      {kit.kitsAvailable != null && <> · <b>{kit.kitsAvailable}</b> kit{kit.kitsAvailable === 1 ? '' : 's'} available {where}</>}
    </Typography>
  );
};

export default KitAvailabilityHint;
